export const HOST = ['', 'https://www.itiger.com'];
export const API = {
    getRates: '/api/pay/rates'
};
